export default "__VITE_ASSET__DU2t1fqz__ 1920w";